  // === Event Coloring ===
  export const getTitleColor = (title = "", event_type = "", primary_technician = "") => {
    const t = title.toLowerCase();
    const tn = primary_technician.toLowerCase();

    if (
      event_type === "birthday"
    ) return "text-black border-white-600 bg-orange-300";

    if (
      event_type === "holiday"
    ) return "text-white border-black bg-black";

    if (
      event_type === "travel"
    ) return "text-black border-yellow-600 bg-yellow-100";

    if (
      event_type === "office"
    ) return "text-black border-blue-600 bg-blue-100";
    
    if (
      event_type === "rest"
    ) return "text-black border-green-600 bg-green-100";
    
    if (
      event_type === "training"
    ) return "text-black border-yellow-600 bg-indigo-300";    

    if (
      event_type === "no_job"
    ) return "text-black border-gray-600 bg-gray-100";

    if (
      t.includes("warehouse closed") ||
      t.includes("closed") ||
      t.includes("depot closed") ||
      t.includes("costco closed") ||
      t.includes("new year") ||
      t.includes("office closed") ||
      t.includes("holiday")
    ) return "text-white border-black bg-black";

    if (
      t.includes("personal leave") ||
      t.includes("time off") ||
      t.includes("pto") ||
      t.includes("rest") ||
      t.includes("half day") ||
      t.includes("holding") ||
      t.includes("per diem") ||
      t.includes("baby") ||
      t.includes("away from home") ||
      t.includes("out of state") ||
      t.includes("unavailable")
    ) return "text-black border-green-600 bg-green-100";

    if (
      t.includes("worked at office") ||
      t.includes("working in office") ||
      t.includes("office only") ||
      t.includes("costco corporate office")
    ) return "text-black border-blue-600 bg-blue-100";

    if (t.includes("no job")
    ) return "text-black border-gray-600 bg-gray-100";

    if (
      t.includes("travel") ||
      t.includes("drive") ||
      t.includes("driving") ||
      t.includes("van")
    ) return "text-black border-yellow-600 bg-yellow-100";

    if (
      tn.includes("fusionsplice") ||
      tn.includes("hightop") ||
      tn.includes("lowtop")
    ) return "text-black border-yellow-600 bg-indigo-300";

    return "text-black border-red-600 bg-red-100";
  };